import { render, staticRenderFns } from "./ModeButton.vue?vue&type=template&id=5fff2bee&"
import script from "./ModeButton.vue?vue&type=script&lang=ts&"
export * from "./ModeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports